const state = {
  card: {
    chave: null,
    titulo: null,
    buscarDados: null
  },
  departamento_compra: {
    iddepartamento: null,
    descricao_departamento: null
  },
  categoria_selecionada: null,
  categorias_pendentes_compra: [],
  callbackAtualizarTabelaCategorias: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackAtualizarCardsTotais: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackAtualizarDetalhesCategoria: () => {
    throw new Error('função ainda não referenciada!');
  }
}

const getters = {
  card_ativo(state) {
    return state.card
  },
  departamento_compra(state) {
    return state.departamento_compra
  },
  categoria_selecionada(state) {
    return state.categoria_selecionada
  },
  categorias_pendentes_compra(state) {
    return state.categorias_pendentes_compra
  },
  callbackAtualizarTabelaCategorias(state) {
    return state.callbackAtualizarTabelaCategorias
  },
  callbackAtualizarCardsTotais(state) {
    return state.callbackAtualizarCardsTotais
  },
  callbackAtualizarDetalhesCategoria(state) {
    return state.callbackAtualizarDetalhesCategoria
  }
}

const mutations = {
  card_ativo(state, valor){
    state.card = valor
  },
  departamento_compra(state, valor){
    state.departamento_compra = valor
  },
  categoria_selecionada(state, valor){
    state.categoria_selecionada = valor
  },
  categorias_pendentes_compra(state, valor){
    state.categorias_pendentes_compra = valor
  },
  callbackAtualizarTabelaCategorias(state, valor){
    state.callbackAtualizarTabelaCategorias = valor
  },
  callbackAtualizarCardsTotais(state, valor){
    state.callbackAtualizarCardsTotais = valor
  },
  callbackAtualizarDetalhesCategoria(state, valor){
    state.callbackAtualizarDetalhesCategoria = valor
  }
}

const actions = {
  card_ativo: ({ commit }, valor) => {
    commit("card_ativo", valor)
  },
  departamento_compra: ({ commit }, valor) => {
    commit("departamento_compra", valor)
  },
  categoria_selecionada: ({ commit }, valor) => {
    commit("categoria_selecionada", valor)
  },
  categorias_pendentes_compra: ({ commit }, valor) => {
    commit("categorias_pendentes_compra", valor)
  },
  callbackAtualizarTabelaCategorias(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de categorias a comprar!`);
    }

    context.commit("callbackAtualizarTabelaCategorias", payload);
  },
  callbackAtualizarCardsTotais(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de categorias a comprar!`);
    }

    context.commit("callbackAtualizarCardsTotais", payload);
  },
  callbackAtualizarDetalhesCategoria(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o detalhes da categoria!`);
    }

    context.commit("callbackAtualizarDetalhesCategoria", payload);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
